import * as React from "react"
const SvgRecommendationOutgoingOnly = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6.48 12.46q.31.236.657.436 2.184 1.263 4.584.628 2.4-.633 3.649-2.799l.087-.151-1.228.329a.95.95 0 0 1-.743-.112.95.95 0 0 1-.469-.588.95.95 0 0 1 .112-.744.95.95 0 0 1 .588-.468l3.548-.952a.96.96 0 0 1 .756.09.96.96 0 0 1 .456.61l.95 3.552q.101.375-.111.743a.95.95 0 0 1-.588.469.95.95 0 0 1-.743-.112.95.95 0 0 1-.468-.588l-.33-1.23-.087.152q-1.674 2.9-4.869 3.74-3.194.838-6.093-.837a7.4 7.4 0 0 1-1.01-.699 8 8 0 0 1-.889-.86.86.86 0 0 1-.23-.725.85.85 0 0 1 .413-.641q.36-.225.77-.161.41.063.716.385.262.295.572.532" />
  </svg>
)
export default SvgRecommendationOutgoingOnly
